export const isEmpty = (value: string | null | undefined): boolean => {
  return value === null || value === undefined || value.trim() === '';
};

export const hasValidNameFormat = (name: string, nameRegex = /^[A-Za-z0-9 _-]+$/): boolean => {
  return nameRegex.test(name);
};

export function isValidPort(value: string | number): boolean {
  const str = String(value);
  if (!/^\d{1,4}$/.test(str)) return false;

  const num = Number(str);
  return Number.isInteger(num) && num >= 0 && num <= 9999;
}

export function isValidPassword(value: string): boolean {
  return /^.{1,50}$/.test(String(value));
}

export function isValidServerAddress(value: string): boolean {
  return /^[A-Za-z0-9.-]{1,50}$/.test(String(value));
}

export function isValidEmail(value: string): boolean {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(value));
}
